import React from "react"

const PleskWebHostDemoBlock = () => {
  return (
    <section className="money-back-block">
      <div className="container-xl">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column justify-content-center">
              <h3 className="mb-4 component-title text-dark-blue">
                Powerful and Intuitive
                <br /> Control Panel- Plesk
              </h3>
              <div className="description py-4">
                A versatile web-based control panel that makes your website
                management easier with the help of a user-friendly Graphic User
                Interface (GUI). Using the Plesk control panel you can easily
                manage your Windows hosting account. Our windows reseller &
                Linux reseller hosting plan comprises of Plesk panel that lets
                you access the below features:
                <br /> <br />
                ✓Websites & Domains ✓Mail ✓Applications ✓Files ✓Databases
                ✓Statistics ✓My Profile ✓WordPress.
              </div>
            </div>
            <div className="get-stated">
              <a
                className="btn btn-width btn-primary me-3"
                target="_blank"
                rel="noreferrer"
                href="https://webhost-win.demo.plesk.com:8443/login_up.php3?login_name=admin&passwd=panel&locale_id=en-US"
              >
                Try Plesk Windows Demo
              </a>
              <a
                className="btn btn-width btn-primary"
                target="_blank"
                rel="noreferrer"
                href="https://webhost-lin.demo.plesk.com:8443/login_up.php3?login_name=admin&passwd=panel&locale_id=en-US"
              >
                Try Plesk Linux Demo
              </a>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="d-flex justify-content-center d-none d-lg-block  p-5">
              <img
                className="img-fluid"
                alt="Plesk Control Panel"
                src="/img/vendors/plesk-obsidian.jpg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PleskWebHostDemoBlock
